/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderDeviationProductionSequence } from '../../models/production-order-deviation-production-sequence';

export interface GetDeviationProductionSequenceReasons$Params {
  productionOrderId: number;
}

export function getDeviationProductionSequenceReasons(http: HttpClient, rootUrl: string, params: GetDeviationProductionSequenceReasons$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderDeviationProductionSequence>> {
  const rb = new RequestBuilder(rootUrl, getDeviationProductionSequenceReasons.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderDeviationProductionSequence>;
    })
  );
}

getDeviationProductionSequenceReasons.PATH = '/api/v1/ProductionOrder/{productionOrderId}/DeviationProductionSequenceReasons';
